module.exports = __webpack_public_path__ + "static/media/thanksgiving.fe68bb18.jpg";